//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin, ViewDocumentSelection, WidgetToolbarRepository } from "ckeditor5";
import { getAccordionSectionWidget } from "./util";

export default class AccordionToolbar extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  public static get requires() {
    return [WidgetToolbarRepository];
  }

  // noinspection JSUnusedGlobalSymbols
  public static get pluginName() {
    return "AccordionToolbar";
  }

  public afterInit() {
    const widgetToolbarRepository = this.editor.plugins.get(WidgetToolbarRepository);
    widgetToolbarRepository.register("accordion", {
      ariaLabel: this.editor.config.get("accordion.toolbarName") as string,
      items: ["addAccordionSection", "removeAccordionSection"],
      getRelatedElement: (selection: ViewDocumentSelection) => getAccordionSectionWidget(selection),
    });
  }
}
